/** Read Atlas branch id(s) from GET /properties/{id} (or list wire extras). */
export function readPropertyBranchId(property: unknown): string | null {
  if (!property || typeof property !== "object") return null;
  const raw = property as Record<string, unknown>;
  const branchId = raw.branchId;

  if (typeof branchId === "string" && branchId.trim()) {
    return branchId.trim();
  }

  if (Array.isArray(branchId)) {
    for (const entry of branchId) {
      if (typeof entry === "string" && entry.trim()) {
        return entry.trim();
      }
    } 
  }

  return null;
}

const branchIdByPropertyId = new Map<string, string | null>();

export function getCachedPropertyBranchId(propertyId: string): string | null | undefined {
  return branchIdByPropertyId.get(propertyId);
}

export function cachePropertyBranchId(propertyId: string, branchId: string | null): void {
  branchIdByPropertyId.set(propertyId, branchId);
}
